import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";
import { FullscreenLoader } from "./Loaders";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { firebaseUser, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <FullscreenLoader label="Checking your session..." />;
  }
  if (!firebaseUser) {
    return (
      <Navigate
        to="/login"
        state={{ from: `${location.pathname}${location.search}` }}
        replace
      />
    );
  }
  return <>{children}</>;
}

export function AdminRoute({ children }: { children: ReactNode }) {
  const { firebaseUser, profile, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <FullscreenLoader label="Checking admin access..." />;
  }
  if (!firebaseUser) {
    return (
      <Navigate
        to="/login"
        state={{ from: `${location.pathname}${location.search}` }}
        replace
      />
    );
  }
  if (!profile?.isAdmin) {
    return (
      <div className="page container">
        <h1>Admin only</h1>
        <p className="muted">
          Your account does not have admin access. Ask an existing admin to run
          <code> python -m backend.admin promote {profile?.email ?? "your-email"}</code>
          and then sign out and back in.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
